// DesignContentPage3.jsx
import dayjs from 'dayjs';
import DateLogic from "..//../utils/DateLogic";
import { formatTimeRange, format12Hour } from "..//../utils/FormatTime";
import { getTranslations } from "..//../utils/CardTranslations";


const DesignContentPage3 = ({ data }) => {
  const t = getTranslations(data.language);
  return (
    <>
      <div style={{ padding: '30px', fontFamily: data.fontStyle, color: data.themeColour || 'black', textAlign: 'center' }}>

        {data.openingText && (
          <p style={{ fontSize: '13px', fontStyle: 'italic', marginTop: '12px' }}>
            {data.openingText}
          </p>
        )}

        {data.eventHost === 'satu' && data.parentName && (
          <p style={{ fontSize: '18px', whiteSpace: 'pre-line', marginTop: "15px", fontFamily: data.fontNamingStyle }}>
            {data.parentName.replace(/ & /g, '\n&\n')}
          </p>
        )}

        {data.eventHost === 'dua' && (
          <>
            {data.parentNameMale && (

              <p style={{ fontSize: '18px', whiteSpace: 'pre-line', marginTop: "15px", fontFamily: data.fontNamingStyle }}>
                <p style={{ fontSize: '10px' }}>{t.groomSide}</p>
                {data.parentNameMale.replace(/ & /g, '\n&\n')}
              </p>
            )}
            <p style={{ fontSize: '11px', whiteSpace: 'pre-line', marginTop: '15px' }}>{t.and}</p>
            {data.parentNameFemale && (
              <p style={{ fontSize: '18px', whiteSpace: 'pre-line', marginTop: "15px", fontFamily: data.fontNamingStyle }}>
                <p style={{ fontSize: '10px' }}>{t.brideSide}</p>
                {data.parentNameFemale.replace(/ & /g, '\n&\n')}
              </p>
            )}
          </>
        )}


        {data.greetingText && (
          <p style={{ fontSize: '11px', whiteSpace: 'pre-line', marginTop: '15px' }}>
            {data.greetingText}
          </p>
        )}

        {data.groomName && data.brideName ? (
          <p style={{ fontSize: '18px', whiteSpace: 'pre-line', marginTop: '15px', fontFamily: data.fontNamingStyle }}>
            {data.eventHost === 'satu' ? (
              data.eventSide === 'lelaki' ? (
                <>
                  {data.groomName} <br />&<br /> {data.brideName}
                </>
              ) : (
                <>
                  {data.brideName} <br />&<br /> {data.groomName}
                </>
              )
            ) : (
              <>
                {data.groomName} <br />&<br /> {data.brideName}
              </>
            )}
          </p>
        ) : (
          <>
            {data.groomName && (
              <p style={{ fontSize: '18px', whiteSpace: 'pre-line', marginTop: '15px', fontFamily: data.fontNamingStyle }}>
                {data.groomName}
              </p>
            )}
            {data.brideName && (
              <p style={{ fontSize: '18px', whiteSpace: 'pre-line', marginTop: '15px', fontFamily: data.fontNamingStyle }}>
                {data.brideName}
              </p>
            )}
          </>
        )}

        {/* ── COUPLE 2 block ────────────────────────────────── */}
        {data.coupleCount === 'dua' && (
          <>
            <div style={{ margin: '20px 0 8px', borderTop: `1px solid ${data.themeColour || "black"}`, opacity: 0.6 }} />

            {data.groomName2 && data.brideName2 ? (
              <p style={{ fontSize: '18px', whiteSpace: 'pre-line', marginTop: '15px', fontFamily: data.fontNamingStyle }}>
                {data.eventHost === 'satu' ? (
                  data.eventSide === 'lelaki' ? (
                    <>
                      {data.groomName2} <br />&<br /> {data.brideName2}
                    </>
                  ) : (
                    <>
                      {data.brideName2} <br />&<br /> {data.groomName2}
                    </>
                  )
                ) : (
                  <>
                    {data.groomName2} <br />&<br /> {data.brideName2}
                  </>
                )}
              </p>
            ) : (
              <>
                {data.groomName2 && <p style={{ fontSize: '18px', whiteSpace: 'pre-line', marginTop: '15px', fontFamily: data.fontNamingStyle }}>{data.groomName2}</p>}
                {data.brideName2 && <p style={{ fontSize: '18px', whiteSpace: 'pre-line', marginTop: '15px', fontFamily: data.fontNamingStyle }}>{data.brideName2}</p>}
              </>
            )}
          </>
        )}

        {data.closingText && (
          <p style={{ fontSize: '11px', marginTop: '15px' }}>
            {data.closingText}
          </p>
        )}


        <p style={{ fontSize: '12px', marginTop: '15px', fontWeight: 'bold' }}>
          {t.date}
        </p>

        <span style={{ display: 'flex', justifyContent: 'center', fontSize: '11px' }}>
          <p>{DateLogic.toDay(dayjs(data.eventDate).format('dddd'), data.language)}</p>
          <p>, {DateLogic.formatDate(data.eventDate, 'D MMM YYYY', data.language)}</p>
        </span>
        {DateLogic.toIslamicDate(data.eventDate, data.language) && (
          <p style={{ fontSize: "9px", marginTop: "1px", opacity: 0.85 }}>
            ( {DateLogic.toIslamicDate(data.eventDate, data.language)} )
          </p>
        )}

        <p style={{ fontSize: '12px', marginTop: '15px', fontWeight: 'bold' }}>
          {t.time}
        </p>
        <p style={{ display: 'flex', justifyContent: 'center', fontSize: '11px' }}>
          {formatTimeRange(data.startTime, data.endTime)}
        </p>

        <p style={{ fontSize: '12px', marginTop: '15px', fontWeight: 'bold' }}>
          {t.venue}
        </p>
        {data.eventAddress && (
          <p style={{ fontSize: '11px', whiteSpace: 'pre-line' }}>
            {data.eventAddress}
          </p>
        )}

        {data.showDressCode && (
          <>
            <p style={{ fontSize: '12px', marginTop: '15px', fontWeight: 'bold' }}>
              {t.dressCode}
            </p>
            <p style={{ fontSize: '11px' }}>
              {data.dressCode}
            </p>

            {/* Colour palette swatches */}
            {Array.isArray(data.dressCodeColours) && data.dressCodeColours.length > 0 && (
              <div style={{ display: 'flex', justifyContent: 'center', gap: '6px', marginTop: '6px', flexWrap: 'wrap' }}>
                {data.dressCodeColours.map((colour, i) => (
                  <div
                    key={i}
                    title={colour}
                    style={{
                      width: 24,
                      height: 24,
                      borderRadius: '50%',
                      backgroundColor: colour,
                      boxShadow: '0 1px 3px rgba(0,0,0,0.15)',
                      flexShrink: 0,
                    }}
                  />
                ))}
              </div>
            )}

            {/* Notes */}
            {data.dressCodeNotes && (
              <p style={{ fontSize: '10px', marginTop: '6px', opacity: 0.7, fontStyle: 'italic', whiteSpace: 'pre-line' }}>
                {data.dressCodeNotes}
              </p>
            )}
          </>
        )}

      </div>

      <div style={{ backgroundColor: data.themeAturCaraColour, width: '100%', paddingTop: '15px', paddingBottom: '15px', marginTop: '20px', textAlign: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
        <p style={{ fontSize: '12px', fontWeight: 'bold', color: 'white' }}>
          {t.programmeTitle}
        </p>
        {data.programmes?.map((p, index) => (
          <div key={index} style={{ color: 'white', display: 'flex', flexDirection: 'column', justifyContent: 'center', fontSize: '11px', marginTop: '15px' }}>
            <span>{format12Hour(p.time)}</span>
            <span>{p.activity}</span>
          </div>
        ))}

      </div>
    </>

  );
};

export default DesignContentPage3;
